import APIRequestState from '../_util/api-request';

/** body: {name, homeCity_id, telephone, email, password} */
class SignupState extends APIRequestState {
  get method() { return 'POST'; }
  get url() { return '/user'; }
}

export default SignupState;



// WEBPACK FOOTER //
// ./spa/state/session/signup.jsx